import { z } from "zod";
export const TeamSummary = z.object({
    id: z.string().uuid(),
    name: z.string(),
    description: z.string().nullable(),
    createdAt: z.string().datetime(),
    repoCount: z.number().int().nonnegative(),
    ticketCount: z.number().int().nonnegative(),
});
export const TeamsListResponse = z.object({
    teams: z.array(TeamSummary),
});
//# sourceMappingURL=teams.js.map